import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, override for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function (Event) {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "icon-editor",
    templateId: "icon-editor-template",

    update: function (element, context) {},

    bind: function (component) {
      var me = this,
        $rootElement = $(this.element);

      $rootElement.on(
        "click",
        ".preview",
        function () {
          var initialValue = component.context;

          function callback(iconName) {
            component.save(iconName);

            // we need to reload the tool now to ensure the ui is re-rendered properly.
            // the loader will handle this when we call this tool 'outdated'.
            Event.trigger("pb:tool:outdated", me);

            me.component.render();
          }

          new Sparkle.PageBuilder.Modal.IconEditor(initialValue, { onComplete: callback }).render();
        }.bind(this),
      );
    },

    unbind: function (element) {
      var $element = $(this.element);

      $element.off("click");
    },
  });
})(Sparkle.PageBuilder.Helpers.Event);
